export default __webpack_public_path__ + "static/media/6_Bohemian.12e89eea.mp3";